import { Box, TableCell, TextField } from "@mui/material";

export const FilterCell = ({ children, colSpan }) => (
  <TableCell
    colSpan={colSpan}
    sx={{
      p: "8px 6px",
      borderBottom: "1px solid #EEF1F7",
      verticalAlign: "middle",
    }}
  >
    <Box sx={{ width: "100%" }}>{children}</Box>
  </TableCell>
);

export const TableFilterInput = ({
  value,
  onChange,
  placeholder,
  select = false,
  children,
  sx,
  ...rest
}) => {
  return (
    <TextField
    {...rest}
      fullWidth
      size="small"
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      select={select}
      sx={{
        "& .MuiOutlinedInput-root": {
          bgcolor: "#EEF3FF",
          borderRadius: "999px",
          height: 34,
          boxShadow: "none",
          px: 1.2,

          "& input": {
            py: 0,
            fontSize: 14,
            color: "#8697C0",
          },

          "& .MuiSelect-select": {
            py: 0,
            fontSize: 14,
            color: "#8697C0",
            display: "flex",
            alignItems: "center",
          },

          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          ...sx,
        },
      }}
    >
      {children}
    </TextField>
  );
};

